/* ==========================================================================
   modab-cart.js — comportamento do carrinho lateral (clone modab)
   - <cart-drawer-estimator>: rodapé Cupom / Frete / Total.
     * Cupom  -> painel inline, ponte para o <cart-discount-component> do Bellamo.
     * Frete  -> modal sobreposto ao carrinho: CEP com máscara + auto-cálculo
                 (ViaCEP p/ UF + Frenet), opções selecionáveis; some ao escolher.
   - Carrossel de recomendação: setas prev/next (scroll horizontal, sem Swiper).
   ========================================================================== */
(function () {
  'use strict';

  var CHEVRON = '<svg viewBox="0 0 16 10" aria-hidden="true" focusable="false"><path d="M1 1.25L8 8.25L15 1.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function money(cents) {
    var v = (Number(cents) / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + v;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  /* --- Frete escolhido: guardado p/ sobreviver ao re-render do carrinho ---
     O rodapé vem do servidor (/cart?view=ajax_side_cart) e é redesenhado a cada
     alteração do carrinho, o que apagaria a escolha de frete e o Total somado.
     Guardamos {zip, name, label, cents, sig}. sig = cart.total_price de quando a
     cotação foi feita; se o carrinho mudou, recotamos na Frenet (o valor do frete
     muda com o peso/valor do pedido). */
  var SHIP_KEY = 'modabShipping';
  function shipRead() { try { return JSON.parse(localStorage.getItem(SHIP_KEY) || 'null'); } catch (e) { return null; } }
  function shipWrite(v) {
    try { v ? localStorage.setItem(SHIP_KEY, JSON.stringify(v)) : localStorage.removeItem(SHIP_KEY); } catch (e) {}
  }

  function rateName(r) { return r.presentment_name || r.name || 'Entrega'; }
  function rateCents(r) { var p = parseFloat(r.price); return isNaN(p) ? 0 : Math.round(p * 100); }
  function rateLabel(cents) { return cents === 0 ? 'GRÁTIS' : money(cents); }

  /* Cotação na Frenet: ViaCEP p/ UF+cidade -> prepare_shipping_rates -> polling. */
  function quoteRates(zip) {
    function poll(q, tries) {
      return fetch('/cart/async_shipping_rates.json?' + q, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var notReady = data === null || (Array.isArray(data && data.shipping_rates) && data.shipping_rates.length === 0 && tries < 6);
          if (notReady && tries < 25) { return new Promise(function (res) { setTimeout(function () { res(poll(q, tries + 1)); }, 700); }); }
          return (data && data.shipping_rates) || [];
        });
    }
    return fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cep) {
        if (cep && cep.erro) throw new Error('cep');
        var uf = (cep && cep.uf) || '';
        var city = (cep && cep.localidade) || '';
        var street = (cep && cep.logradouro) || '';
        /* Envia tambem a rua (address1) p/ o checkout ja vir com o Endereco preenchido,
           nao so o CEP. O bairro nao e aceito aqui, fica com o cliente. Nao muda a cotacao. */
        var addr = 'shipping_address[zip]=' + encodeURIComponent(zip) +
                   '&shipping_address[country]=Brazil' +
                   (uf ? '&shipping_address[province]=' + encodeURIComponent(uf) : '') +
                   (city ? '&shipping_address[city]=' + encodeURIComponent(city) : '') +
                   (street ? '&shipping_address[address1]=' + encodeURIComponent(street) : '');
        var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) +
                '&shipping_address%5Bcountry%5D=Brazil' +
                (uf ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf) : '');
        return fetch('/cart/prepare_shipping_rates.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: addr
        }).then(function () { return poll(q, 0); });
      });
  }

  /* --- Barra de desconto progressivo (lê config da seção + estado do carrinho) --- */
  function renderProgressBar(container, _retry) {
    if (!container) return;
    clearTimeout(container._cdsCountdown);
    var cfgEl = document.getElementById('cds-progress-config');
    if (!cfgEl) {
      // A config vem da seção no rodapé; pode não estar no DOM no 1º render. Re-tenta.
      if ((_retry || 0) < 20 && container.isConnected) {
        setTimeout(function () { renderProgressBar(container, (_retry || 0) + 1); }, 150);
      }
      return;
    }
    var cfg = null;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; }
    if (!cfg || !cfg.enabled || !cfg.tiers || !cfg.tiers.length) { container.innerHTML = ''; return; }
    // Validade (Configurações do tema → Início/Fim). Checada no navegador porque a página
    // pode vir do cache do Shopify. Data inválida = ignorada, como no popup contagem regressiva.
    var now = Date.now();
    var endTime = cfg.end ? new Date(cfg.end).getTime() : NaN;
    if (cfg.start && now < new Date(cfg.start).getTime()) { container.innerHTML = ''; return; }
    if (now >= endTime) { container.innerHTML = ''; return; }

    var mode = cfg.mode || 'value';
    var totalCents = parseInt(container.getAttribute('data-cds-total') || '0', 10);
    var count = parseInt(container.getAttribute('data-cds-count') || '0', 10);
    var current = mode === 'quantity' ? count : totalCents / 100;

    var tiers = cfg.tiers.slice().filter(function (t) { return t && t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
    if (!tiers.length) { container.innerHTML = ''; return; }
    var maxMin = tiers[tiers.length - 1].min;
    var nT = tiers.length;
    var seg = 100 / nT;

    // Marcos ficam IGUALMENTE espaçados (33%, 66%, 100% para três níveis).
    // Posicioná-los pelo valor deixava metas próximas coladas — com 299/399/599
    // os rótulos se sobrepunham. O preenchimento vira então por SEGMENTO: dentro
    // de cada trecho o avanço continua proporcional, então a barra não mente.
    var pct = 0;
    if (current > 0) {
      var kk = -1;
      for (var pi = 0; pi < nT; pi++) { if (current >= tiers[pi].min) kk = pi; }
      if (kk >= nT - 1) {
        pct = 100;
      } else {
        var base = (kk + 1) * seg;
        var lo = kk < 0 ? 0 : tiers[kk].min;
        var hi = tiers[kk + 1].min;
        var frac = hi > lo ? (current - lo) / (hi - lo) : 0;
        pct = Math.max(0, Math.min(100, base + frac * seg));
      }
    }

    function fmtVal(v) { return mode === 'quantity' ? (v + ' ' + (v === 1 ? 'item' : 'itens')) : money(Math.round(v * 100)); }

    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (current < tiers[i].min) { next = tiers[i]; break; } }
    var text;
    if (next) {
      text = (cfg.textNext || 'Faltam {faltam} para {recompensa}')
        .replace('{faltam}', fmtVal(next.min - current))
        .replace('{recompensa}', next.reward || '');
    } else {
      text = (cfg.textReached || 'Você desbloqueou {recompensa}!')
        .replace('{recompensa}', tiers[tiers.length - 1].reward || '');
    }

    var markers = tiers.map(function (t, ti) {
      var left = (ti + 1) / nT * 100;
      var reached = current >= t.min;
      // Topo do marco mostra QUANTO FALTA GASTAR. Antes só aparecia se o lojista
      // preenchesse um label, e o emissor grava label vazio fixo — então nunca aparecia.
      var topText = (t.label && t.label !== '') ? t.label : fmtVal(t.min);
      var topLabel = '<span class="cds-progress__mk-top">' + esc(topText) + '</span>';
      return '<div class="cds-progress__mk' + (reached ? ' is-reached' : '') + '" style="left:' + left + '%">' +
        topLabel +
        '<span class="cds-progress__dot"></span>' +
        '<span class="cds-progress__mk-reward">' + esc(t.reward || '') + '</span>' +
      '</div>';
    }).join('');

    // Nível conquistado MAIS ALTO: cada nível tem o seu cupom, então a mensagem
    // de sucesso precisa ser a dele, não uma genérica de "desbloqueou tudo".
    var wonTier = null;
    for (var wi = 0; wi < tiers.length; wi++) { if (current >= tiers[wi].min) wonTier = tiers[wi]; }
    var wonMsg = wonTier
      ? String(wonTier.reached || cfg.textReached || '').replace('{recompensa}', wonTier.reward || '')
      : '';
    // Sem próximo nível, a caixa de sucesso já diz tudo: não repetir no topo.
    if (!next && wonMsg) text = '';

    var timerHtml = Number.isFinite(endTime) ? '<span class="cds-progress__countdown" role="timer" aria-live="off"><svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor"/><path d="M8 4v4l2.5 1.5" fill="none" stroke="currentColor" stroke-linecap="round"/></svg><span data-cds-countdown></span></span>' : '';
    var titleHtml = cfg.title ? '<p class="cds-progress__title"><span>' + esc(cfg.title) + '</span>' + timerHtml + '</p>' : '';
    var textHtml = text ? '<p class="cds-progress__text">' + esc(text) + '</p>' : '';
    var wonHtml = wonMsg ? '<p class="cds-progress__won">' + esc(wonMsg) + '</p>' : '';

    container.style.setProperty('--cds-color', cfg.color || '#16b180');
    container.innerHTML =
      titleHtml +
      textHtml +
      '<div class="cds-progress__bar">' +
        '<div class="cds-progress__track">' +
          '<div class="cds-progress__fill" style="width:' + pct + '%"></div>' +
          markers +
        '</div>' +
      '</div>' +
      wonHtml;

    var timer = container.querySelector('[data-cds-countdown]');
    if (timer) {
      function updateCountdown() {
        if (!container.isConnected) return;
        var remaining = endTime - Date.now();
        if (remaining <= 0) { container.innerHTML = ''; return; }
        var seconds = Math.ceil(remaining / 1000);
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor(seconds / 3600) % 24;
        var minutes = Math.floor(seconds / 60) % 60;
        function pad(value) { return String(value).padStart(2, '0'); }
        var clock = (days ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds % 60);
        // Só troca o texto do nó: não redesenha nem acorda quem observa a página a cada segundo.
        if (timer.firstChild) timer.firstChild.data = clock; else timer.textContent = clock;
        timer.parentElement.setAttribute('aria-label', 'Oferta termina em ' + (days ? days + ' dias, ' : '') + hours + ' horas, ' + minutes + ' minutos e ' + (seconds % 60) + ' segundos');
        container._cdsCountdown = setTimeout(updateCountdown, Math.min(1000, remaining));
      }
      updateCountdown();
    }
  }

  if (!window.customElements || customElements.get('cart-drawer-estimator')) {
    initRecommend();
    return;
  }

  var CartDrawerEstimator = class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-estimator-panel]');
      this.summary = this.querySelector('[data-estimator-summary]');
      this.baseTotal = parseInt(this.getAttribute('data-cart-total') || '0', 10);
      this.shipCents = 0;
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
      var info = this.closest('.previewCartInfo');
      var pb = info && info.querySelector('[data-cds-progress]');
      if (pb) renderProgressBar(pb);
      this.restoreShipping();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      var t = e.target.closest('button');
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-open-coupon')) { e.preventDefault(); this.openCoupon(); }
      else if (t.hasAttribute('data-open-shipping')) { e.preventDefault(); this.openShipping(); }
      else if (t.hasAttribute('data-estimator-back')) { e.preventDefault(); this.closePanel(); }
      else if (t.hasAttribute('data-apply-coupon')) { e.preventDefault(); this.applyCoupon(); }
      else if (t.hasAttribute('data-remove-coupon')) { e.preventDefault(); this.removeCoupon(t.getAttribute('data-code'), t); }
    }

    closePanel() {
      if (!this.panel) return;
      this.panel.hidden = true;
      this.panel.innerHTML = '';
    }

    /* --- Cupom (painel inline) --- */
    openCoupon() {
      if (!this.panel) return;
      this.panel.innerHTML =
        '<div class="cart-drawer-estimator__panel-header">' +
          '<h3>Cupom</h3>' +
          '<button type="button" class="cart-drawer-estimator__close-arrow" aria-label="Fechar" data-estimator-back>' + CHEVRON + '</button>' +
        '</div>' +
        '<div class="cart-drawer-estimator__form">' +
          '<label for="cart-drawer-coupon">Digite o código</label>' +
          '<div class="cart-drawer-estimator__field-row">' +
            '<input id="cart-drawer-coupon" type="text" name="discount" value="" autocomplete="off" autocapitalize="characters">' +
            '<button type="button" data-apply-coupon>Aplicar</button>' +
          '</div>' +
          '<p class="cart-drawer-estimator__message" data-estimator-message></p>' +
        '</div>';
      this.panel.hidden = false;
      var input = this.panel.querySelector('#cart-drawer-coupon');
      if (input) input.focus();
      var self = this;
      if (input) input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); self.applyCoupon(); } });
    }

    msg(text, type) {
      var el = this.panel && this.panel.querySelector('[data-estimator-message]');
      if (!el) return;
      el.textContent = text || '';
      el.className = 'cart-drawer-estimator__message' + (type ? ' is-' + type : '');
    }

    applyCoupon() {
      var input = this.panel && this.panel.querySelector('#cart-drawer-coupon');
      var code = input ? input.value.trim() : '';
      if (!code) { this.msg('Informe um código de cupom.', 'error'); return; }
      this.msg('Aplicando...', '');
      var root = this.closest('.previewCartInfo') || document;
      var bridge = root.querySelector('.cart-drawer-estimator__coupon-bridge cart-discount-component');
      var form = bridge && bridge.querySelector('.discount-form');
      var field = form && form.querySelector('input[name="discount"]');
      if (form && field) {
        field.value = code;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        this.msg('', '');
        return;
      }
      var self = this;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { return r.json(); })
        .then(function () { self.msg('Cupom aplicado.', 'success'); document.dispatchEvent(new CustomEvent('cart-update')); })
        .catch(function () { self.msg('Não foi possível aplicar o cupom.', 'error'); });
    }

    async removeCoupon(code, button) {
      if (!code || this._removingCoupon) return;
      this._removingCoupon = true;
      var oldHtml = button ? button.innerHTML : '';
      var oldLabel = button ? button.getAttribute('aria-label') : '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-label', 'Removendo cupom ' + code);
        button.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="42 15"/></svg>';
      }
      var status = this.querySelector('[data-coupon-status]');
      if (status) status.remove();
      var root = this.closest('.previewCartInfo') || document;
      var bridge = root.querySelector('.cart-drawer-estimator__coupon-bridge cart-discount-component');
      var codes = new Set(bridge && bridge.appliedDiscounts ? Array.from(bridge.appliedDiscounts) : []);
      root.querySelectorAll('[data-remove-coupon]').forEach(function (item) { codes.add(item.getAttribute('data-code')); });
      var remaining = Array.from(codes).filter(function (item) {
        return item && item.toUpperCase() !== code.toUpperCase();
      });
      try {
        var response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') })
        });
        var cart = await response.json();
        if (!response.ok || (cart.status && cart.status !== 200)) throw new Error('remove');
        if (Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (item) {
          return item.code.toUpperCase() === code.toUpperCase();
        })) throw new Error('remove');
        var saved = Array.isArray(cart.discount_codes) ? cart.discount_codes.map(function (item) { return item.code; }) : remaining;
        if (bridge) bridge.appliedDiscounts = new Set(saved);
        try { localStorage.setItem('appliedDiscounts', JSON.stringify(saved)); } catch (e) {}
        document.dispatchEvent(new CustomEvent('discount:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: bridge && bridge.dataset.sectionId }
        }));
        var refresh = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
        if (typeof refresh === 'function') refresh(cart);
        else if (typeof window.updateCart === 'function') window.updateCart();
        else window.location.reload();
      } catch (error) {
        this._removingCoupon = false;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.setAttribute('aria-label', oldLabel);
          button.innerHTML = oldHtml;
        }
        status = document.createElement('p');
        status.setAttribute('data-coupon-status', '');
        status.setAttribute('role', 'alert');
        status.className = 'cart-drawer-estimator__message is-error';
        status.textContent = 'Não foi possível remover o cupom. Toque no × para tentar novamente.';
        this.appendChild(status);
      }
    }

    /* --- Frete: modal sobreposto ao carrinho --- */
    openShipping() {
      var drawer = document.getElementById('halo-cart-sidebar');
      if (!drawer) return;
      var old = drawer.querySelector('.cds-ship-modal');
      if (old) old.remove();

      var modal = document.createElement('div');
      modal.className = 'cds-ship-modal';
      modal.innerHTML =
        '<div class="cds-ship-modal__backdrop" data-ship-close></div>' +
        '<div class="cds-ship-modal__sheet">' +
          '<button type="button" class="cds-ship-modal__close" aria-label="Fechar" data-ship-close>' + ICON_X + '</button>' +
          '<h3 class="cds-ship-modal__title">Cálculo de frete</h3>' +
          '<input class="cds-ship-modal__input" id="cds-ship-zip" type="text" inputmode="numeric" enterkeyhint="done" placeholder="00000-000" maxlength="9" autocomplete="postal-code">' +
          '<div class="cds-ship-modal__loader" aria-hidden="true"><span></span></div>' +
          '<p class="cds-ship-modal__msg" data-ship-msg></p>' +
          '<div class="cds-ship-modal__rates" data-ship-rates></div>' +
        '</div>';
      drawer.appendChild(modal);
      requestAnimationFrame(function () { modal.classList.add('is-open'); });

      var self = this;
      var input = modal.querySelector('#cds-ship-zip');
      setTimeout(function () { input.focus(); }, 50);
      var timer;
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        input.value = v;
        clearTimeout(timer);
        if (v.replace(/\D/g, '').length === 8) { timer = setTimeout(function () { self.calcShipping(modal); }, 350); }
      });
      input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); self.calcShipping(modal); } });

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-ship-close]')) { self.closeShipModal(modal); return; }
        var opt = e.target.closest('[data-ship-rate]');
        if (opt) { self.selectRate(opt); self.closeShipModal(modal); }
      });
    }

    closeShipModal(modal) {
      modal.classList.remove('is-open');
      setTimeout(function () { if (modal && modal.parentNode) modal.remove(); }, 260);
    }

    calcShipping(modal) {
      var input = modal.querySelector('#cds-ship-zip');
      var zip = input ? input.value.replace(/\D/g, '') : '';
      var msgEl = modal.querySelector('[data-ship-msg]');
      var rates = modal.querySelector('[data-ship-rates]');
      var loader = modal.querySelector('.cds-ship-modal__loader');
      function stop() { if (loader) loader.classList.remove('is-active'); }
      function fail(t) { stop(); if (msgEl) msgEl.textContent = t; }
      if (zip.length !== 8) { fail('Digite um CEP válido (8 dígitos).'); return; }
      // Grava o CEP novo antes de cotar: senão o reenvio ao checkout volta a cotar o CEP antigo por cima.
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (rates) rates.innerHTML = '';
      if (msgEl) msgEl.textContent = '';
      if (loader) loader.classList.add('is-active');
      var self = this;
      this._zip = zip;

      quoteRates(zip)
        .then(function (list) { stop(); self.renderRates(rates, list, msgEl); })
        .catch(function (e) {
          fail(e && e.message === 'cep' ? 'CEP não encontrado.' : 'Não foi possível calcular o frete.');
        });
    }

    renderRates(container, list, msgEl) {
      if (!container) return;
      if (!list.length) { if (msgEl) msgEl.textContent = 'Nenhuma opção de entrega para este CEP.'; return; }
      container.innerHTML = list.map(function (r) {
        var name = rateName(r);
        var cents = rateCents(r);
        var priceLabel = rateLabel(cents);
        var days = '';
        if (r.delivery_days && r.delivery_days.length) { days = 'até ' + r.delivery_days[r.delivery_days.length - 1] + ' dias úteis'; }
        return '<button type="button" class="cds-rate" data-ship-rate data-name="' + esc(name) + '" data-price="' + esc(priceLabel) + '" data-cents="' + cents + '">' +
          '<span class="cds-rate__radio"></span>' +
          '<span class="cds-rate__text"><span class="cds-rate__main"><b>' + esc(priceLabel) + '</b> - ' + esc(name) + '</span>' +
          (days ? '<small>(' + days + ')</small>' : '') + '</span>' +
        '</button>';
      }).join('');
    }

    selectRate(opt) {
      var name = opt.getAttribute('data-name') || '';
      var label = opt.getAttribute('data-price') || '';
      var cents = parseInt(opt.getAttribute('data-cents') || '0', 10) || 0;
      this.paintRate(name, label, cents);
      shipWrite({ zip: this._zip || '', name: name, label: label, cents: cents, sig: this.baseTotal });
    }

    /* Pinta a linha "Frete" e refaz o Total (produtos já com desconto + frete). */
    paintRate(name, label, cents) {
      var shortName = String(name).split('|')[0].trim();
      var slot = this.querySelector('[data-shipping-summary]');
      if (slot) {
        slot.innerHTML = '<button type="button" class="cart-drawer-estimator__link cds-selected-rate" data-open-shipping title="' + esc(shortName) + '">' +
          esc(label) + ' · ' + esc(shortName) + '</button>';
      }
      this.shipCents = cents || 0;
      this.paintTotal();
    }

    paintTotal() {
      var el = this.querySelector('[data-estimator-total]');
      if (el) el.innerHTML = '<strong>' + money(this.baseTotal + (this.shipCents || 0)) + '</strong>';
    }

    clearRate() {
      var slot = this.querySelector('[data-shipping-summary]');
      if (slot) slot.innerHTML = '<button type="button" class="cart-drawer-estimator__link" data-open-shipping>Inserir CEP</button>';
      this.shipCents = 0;
      this.paintTotal();
      shipWrite(null);
    }

    /* Repõe a escolha após o re-render. Se o carrinho mudou desde a cotação,
       recota: o frete varia com peso/valor (e some no frete grátis da Frenet). */
    restoreShipping() {
      var saved = shipRead();
      if (!saved || !saved.zip || !saved.name) return;
      this._zip = saved.zip;
      this.paintRate(saved.name, saved.label, saved.cents);
      if (saved.sig === this.baseTotal) return;
      var self = this;
      quoteRates(saved.zip).then(function (list) {
        if (!self.isConnected) return;
        var hit = null;
        for (var i = 0; i < list.length; i++) { if (rateName(list[i]) === saved.name) { hit = list[i]; break; } }
        if (!hit) { self.clearRate(); return; }
        var cents = rateCents(hit);
        var label = rateLabel(cents);
        self.paintRate(saved.name, label, cents);
        shipWrite({ zip: saved.zip, name: saved.name, label: label, cents: cents, sig: self.baseTotal });
      }).catch(function () {});
    }
  };

  customElements.define('cart-drawer-estimator', CartDrawerEstimator);

  /* --- Setas do carrossel de recomendação (delegação global) --- */
  function initRecommendArrows() {
    if (window.__modabRecArrows) return;
    window.__modabRecArrows = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rec-prev],[data-rec-next]');
      if (!btn) return;
      e.preventDefault();
      var container = btn.closest('.recommend-container');
      var slider = container && container.querySelector('.recommend-slider');
      if (!slider) return;
      var card = slider.querySelector('.item-recommend');
      var step = card ? card.offsetWidth + 8 : 150;
      slider.scrollBy({ left: btn.hasAttribute('data-rec-prev') ? -step * 2 : step * 2, behavior: 'smooth' });
    });
  }

  /* --- "Leve também": recomendação real do Shopify --------------------------
     O servidor renderiza uma lista fixa (as primeiras da coleção configurada).
     Aqui trocamos por produtos relacionados ao último item do carrinho, via
     /recommendations/products.json. Se a API falhar ou vier vazia, a lista fixa
     do servidor continua na tela — nunca fica um espaço em branco. */
  function recImgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function recCard(p) {
    var v = (p.variants || [])[0];
    var img = p.featured_image || (p.images || [])[0] || '';
    var href = p.url || ('/products/' + p.handle);
    var canAdd = v && v.available !== false;
    return '<div class="item-recommend" data-product-id="' + p.id + '" data-product-handle="' + esc(p.handle) + '" role="group">' +
        '<a class="item-recommend__link" href="' + esc(href) + '">' +
          '<span class="image" title="' + esc(p.title) + '">' +
            (img ? '<img src="' + esc(recImgUrl(img, 344)) + '" width="344" height="516" alt="' + esc(p.title) + '" class="recommend-item-image" loading="lazy">' : '') +
          '</span>' +
          '<span class="infoProduct">' +
            '<h4>' + esc(p.title) + '</h4>' +
            '<span class="price">' + money(p.price) + '</span>' +
          '</span>' +
        '</a>' +
        (canAdd
          ? '<button type="button" class="item-recommend__add" data-rec-add data-variant-id="' + v.id + '" aria-label="Adicionar ' + esc(p.title) + ' ao carrinho">Adicionar</button>'
          : '<button type="button" class="item-recommend__add is-disabled" disabled>Esgotado</button>') +
      '</div>';
  }

  function enhanceRecommendations() {
    var box = document.querySelector('#halo-cart-sidebar .recommend-container');
    if (!box || box.hasAttribute('data-rec-done')) return;
    var seed = box.getAttribute('data-rec-seed');
    var track = box.querySelector('[data-rec-track]');
    if (!seed || !track) return;
    box.setAttribute('data-rec-done', '1');

    var exclude = (box.getAttribute('data-rec-exclude') || '').split(',').filter(Boolean);
    var limit = parseInt(box.getAttribute('data-rec-limit') || '5', 10) || 5;

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=12&intent=related',
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var list = (data && data.products) || [];
        var out = list.filter(function (p) { return exclude.indexOf(String(p.id)) === -1; }).slice(0, limit);
        if (!out.length) return;                 /* sem recomendação: mantém a lista fixa */
        track.innerHTML = out.map(recCard).join('');
      })
      .catch(function () {});
  }

  function initRecommendSmart() {
    if (window.__modabRecSmart) return;
    window.__modabRecSmart = true;
    enhanceRecommendations();
    var host = document.getElementById('halo-cart-sidebar');
    if (!host || !window.MutationObserver) return;
    /* O drawer inteiro é redesenhado pelo servidor a cada mudança do carrinho;
       o observer reaplica a recomendação no HTML novo. O data-rec-done segura
       o custo em uma checagem de atributo. */
    new MutationObserver(function () { enhanceRecommendations(); })
      .observe(host, { childList: true, subtree: true });
  }

  /* --- Botão "Adicionar" dos cards de recomendação --------------------------
     Um clique = um POST em /cart/add.js. Como todo produto da loja tem uma
     variante só (Tamanho U), não há tamanho a escolher. Depois pede o carrinho
     e manda o tema redesenhar o drawer, que recalcula barras, total e a própria
     lista de recomendação. */
  function initRecommendAdd() {
    if (window.__modabRecAdd) return;
    window.__modabRecAdd = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rec-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adicionando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          /* O tema expõe o redesenho do drawer em window.sharedFunctions
             (theme.js linha 75). Não existe window.halo global. */
          var fn = (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) ||
                   (window.halo && window.halo.updateSidebarCart);
          if (typeof fn === 'function') {
            fn(cart);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  function initRecommend() {
    initRecommendArrows();
    initRecommendAdd();
    initRecommendSmart();
  }
  initRecommend();
})();


